import React from 'react'
import EntityProfileLink from '../watchlist/EntityProfileLink'

/**
 * Secondary line for a company that has since been renamed:
 *   --> Nu: Current Name ApS
 */
const CompanyRenamedLine: React.FC<{
  navnNu: string
  cvrNummer?: string | null
  dense?: boolean
}> = ({ navnNu, cvrNummer, dense = false }) => (
  <p className={`text-ink-500 ${dense ? 'text-[10px] mt-0 pl-0 truncate' : 'text-xs mt-0.5 pl-3'}`}>
    <span aria-hidden className="text-ink-400 mr-1">
      --&gt;
    </span>
    Nu:{' '}
    {cvrNummer ? (
      <EntityProfileLink
        to={`/company/${cvrNummer}`}
        entityType="company"
        entityId={String(cvrNummer)}
        className="hover:underline decoration-signal underline-offset-2"
      >
        {navnNu}
      </EntityProfileLink>
    ) : (
      navnNu
    )}
  </p>
)

export default CompanyRenamedLine
